import React from "react"
import Header from "../components/global/Header"
import Footer from "../components/global/Footer"
import about1 from "../assets/images/about-1.png"
import about2 from "../assets/images/about-2.png"
import about3 from "../assets/images/about-3.png"
import about4 from "../assets/images/about-4.png"
import AboutTeam from "../components/about/AboutTeam"
import Hero from "../components/Hero"


// About Page
export default function Home() {
  return (
    <div>
      <Header />
      <Hero title="About Us" subtitle="With Healthify, anyone can easily get connected with 
        registered pharmacy to get drugs at your convenient space"/>
      <div className="about">
        <div className="main ">
          <div className="content-row-odd">
            <div className="col1odd">
              <h1 className="about__title">
                DATA AND TECHNOLOGY
              </h1>
              <h5 className="about__subtitle">Our Story</h5>
              <p className="about__content">
                It all started with SauceCode Hackathon 2020,
                while trying to profer solution a business problem in the health sector. After vetting the problems related to this problems, an idea came up
                "How easy would it be to locate registered pharmacy stores with the option to search the kind of medicine they sell without much trouble!?"
              </p>
            </div>
            <div className="col1">
              <img
                src={about1}
                alt="loading.."
                className="about__image"
              />
            </div>

          </div>
          <div className="content-row">
            <div className="col1">
              <img
                src={about2}
                alt="loading.."
                className="about__image"
              />
            </div>
            <div className="col2">
              <h1 className="about__title">
                DATA AND TECHNOLOGY
              </h1>
              <h5 className="about__subtitle">Our Vision</h5>
              <p className="about__content">
                We want to make the purchase of medicine in the country easier and safer .
                We are hoping to reach out to as many as possible in this part of the country
              </p>
            </div>
          </div>
          <div className="content-row-odd">
            <div className="col1odd">
              <h1 className="about__title">
                DATA AND TECHNOLOGY
              </h1>
              <h5 className="about__subtitle">Our Mission</h5>
              <p className="about__content">
                Our mission is to help locate pharmacy stores near individuals,
                narrowing down the search to the inventory of the pharmacy stores
                without the fear of purchasing illegal/fake drugs which in turn boosts
                the profit rate of registered pharmacy stores
              </p>

            </div>
            <div className="col1">
              <img
                src={about3}
                alt="loading.."
                className="about__image"
              />
            </div>

          </div>
          <div className="content-row">
            <div className="col1">
              <img
                src={about4}
                alt="loading.."
                className="about__image"
              />
            </div>
            <div className="col2">
              <h1 className="about__title">
                DATA AND TECHNOLOGY
              </h1>
              <h5 className="about__subtitle">Our Values</h5>
              <p className="about__content">
                Honesty is what Healthify is all about. Though profits will be made,
                we won't reduce our standard of locating only registered stores around you.
              </p>

            </div>
          </div>
        </div>
        <AboutTeam />
      </div>
      <Footer />
    </div>
  )
}
